// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx={7.5} cy={7.5} r={7.5} fill="currentColor" />
      <path
        d="M5.03 10.628a.924.924 0 0 0 1.29.021l5.254-4.95a.924.924 0 1 0-1.267-1.345L5.709 8.686 4.592 7.558A.924.924 0 1 0 3.279 8.86l1.751 1.769z"
        fill="#FFF"
      />
    </svg>
  );
};

const RatingPositiveIcon = Icon;
export default RatingPositiveIcon;
